import React from 'react'
import {
  useFindOrCreateLocationConfiguration,
  useGetLocationConfigurables,
  useUpdateLocationConfiguration,
} from 'src/api/queries/trade'
import ConfigurationPanel from 'src/components/configuration-panel/ConfigurationPanel'
import { useToast } from 'src/utils/toast'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Button, VStack } from '@chakra-ui/react'
import { useCompanyContext } from 'src/companies/routes/company-context'
import { getEnvironment } from 'src/utils'
import { ArrowBackIcon } from '@chakra-ui/icons'

export default function LocationConfigPage() {
  const { company } = useCompanyContext()
  const toast = useToast()
  const navigate = useNavigate()
  const { id: locationId } = useParams()
  const { data: configurables } = useGetLocationConfigurables()
  const { data: locationConfig } = useFindOrCreateLocationConfiguration({ locationId })
  const { mutateAsync } = useUpdateLocationConfiguration()

  const locationsIndexPath = [
    null,
    'companies',
    getEnvironment(),
    company.slug,
    'markets',
    '#Locations',
  ].join('/')

  const onSave = async (updateData: KeyValuePair[]) => {
    await mutateAsync({
      update: {
        locationId,
        configurations: updateData,
      },
    })
    toast({ title: 'Success', description: 'Updated location configurations' })
  }

  return (
    <VStack spacing={4} alignItems="start" width="100%">
      <Button
        variant="link"
        colorScheme="primary"
        leftIcon={<ArrowBackIcon />}
        onClick={() => navigate(locationsIndexPath)}
      >
        Back
      </Button>
      <Box w="100%">
        <ConfigurationPanel
          configurations={configurables}
          data={locationConfig}
          onSave={onSave}
          editPermission="offer_management_edit"
          alwaysExpanded
        />
      </Box>
    </VStack>
  )
}
